import { useEffect, useState } from 'react';
import { Image, Nav } from 'react-bootstrap';
import { FaBook, FaChartBar, FaDesktop, FaFileContract, FaHouseUser, FaMoneyCheckAlt, FaRegCalendarCheck, FaShip, FaSignOutAlt, FaStoreAlt, FaTools, FaTractor, FaUserCog, FaUsers, FaWarehouse } from 'react-icons/fa';
import { MdAddBusiness, MdAssessment, MdDashboard, MdOutlineDashboard, MdRule,MdSearch, MdAppRegistration, MdSchedule, MdNotificationImportant, MdSportsSoccer, MdDeliveryDining, MdReportProblem, MdPeople, MdManageSearch, MdCurrencyExchange} from 'react-icons/md';
import { v4 as uuid } from 'uuid';

import { MenuItem } from './side-menu-item.component';

import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import BadgeIcon from '@mui/icons-material/Badge';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import HistoryIcon from '@mui/icons-material/History';
import InventoryIcon from '@mui/icons-material/Inventory';
import PersonIcon from '@mui/icons-material/Person';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import ShareIcon from '@mui/icons-material/Share';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import WashIcon from '@mui/icons-material/Wash';
import { BiCategory } from 'react-icons/bi';
import { GiCash } from "react-icons/gi";
import { ImMakeGroup, ImUserTie } from 'react-icons/im';
import { RiBillLine, RiContactsBookFill } from 'react-icons/ri';
import Logo from '../assets/images/logo_registrada.png';
import { useTranslateContext } from '../contexts/translate.context';
import authService from '../services/auth.service';
import styles from './side-menu.component.module.scss';

import VideoMapaEmbarcacoes from '../assets/videos/04_mapa_embarcacoes.mp4';
import VideoPainelCompartilhamento from '../assets/videos/05_painel_compartilhamento.mp4';
import VideoPainelGestaoOficina from '../assets/videos/06_painel_gestao_oficina.mp4';
import VideoPainelGestaoEstoque from '../assets/videos/07_painel_gestao_estoque.mp4';
import VideoPainelGestaoHoraria from '../assets/videos/08_painel_gestao_horaria.mp4';
import VideoPainelMovimentacao from '../assets/videos/09_painel_movimentacao.mp4';
import VideoPainelBeneficio from '../assets/videos/12_painel_gestao_beneficio.mp4';

import ReactPlayer from 'react-player';

export const menuItems = [
    {
        name: 'dashboard',
        to: '/portal/dashboard',
        iconClassName: <FaDesktop size={23} />,
        subMenus: [
            /*{ name: 'customize', to: '/portal/dashboard/customize', iconClassName: <DashboardCustomizeIcon /> },*/
            { name: 'mng_daily', to: '/portal/dashboard/maritime', iconClassName: <MdDashboard size={23} />, video: <ReactPlayer url={VideoPainelMovimentacao} playing={true} /> },
            /*{ name: 'cleaning_management', to: '/portal/dashboard/cleaning', iconClassName: <WashIcon className={styles.menuIcon} /> },*/
            { name: 'mng_financial', to: '/portal/dashboard/financial', iconClassName: <RiBillLine size={23} /> },
            { name: 'mng_cleaning', to: '/portal/dashboard/cleaning', iconClassName: <WashIcon className={styles.menuIcon} /> },
            /*{ name: 'stock', to: '/portal/dashboard/stock', iconClassName: <InventoryIcon className={styles.menuIcon} /> },
            { name: 'sharing_management', to: '/portal/dashboard/sharing', iconClassName: <ShareIcon className={styles.menuIcon} /> },
            { name: 'service_center_management', to: '/portal/dashboard/service-center', iconClassName: <FaTools size={23} /> },
            { name: 'delivery_management', to: '/portal/dashboard/delivery', iconClassName: <FastfoodIcon className={styles.menuIcon} /> },
            { name: 'hourly_occupation', to: '/portal/dashboard/hourly-occupation', iconClassName: <QueryBuilderIcon className={styles.menuIcon} /> },
            { name: 'hourly_prediction', to: '/portal/dashboard/hourly-prediction', iconClassName: <HistoryIcon className={styles.menuIcon} /> },*/
            { divider: true },
            /*{ name: 'management_daily', to: '/portal/dashboard/maritime', iconClassName: <MdDashboard size={23} /> },*/
            /*{ name: 'management_financial', to: '/portal/dashboard/financial', iconClassName: <RiBillLine size={23} /> },*/
            /*{ name: 'cleaning_management', to: '/portal/dashboard/cleaning', iconClassName: <WashIcon className={styles.menuIcon} /> },*/
            { name: 'mng_stock', to: '/portal/dashboard/stock', iconClassName: <InventoryIcon className={styles.menuIcon} />, video: <ReactPlayer url={VideoPainelGestaoEstoque} playing={true} /> },
            { name: 'mng_sharing', to: '/portal/dashboard/sharing', iconClassName: <ShareIcon className={styles.menuIcon} />, video: <ReactPlayer url={VideoPainelCompartilhamento} playing={true} /> },
            { name: 'mng_service_center', to: '/portal/dashboard/service-center', iconClassName: <FaTools size={23} />, video: <ReactPlayer url={VideoPainelGestaoOficina} playing={true} /> },
            { name: 'mng_delivery', to: '/portal/dashboard/delivery', iconClassName: <FastfoodIcon className={styles.menuIcon} /> },
            { name: 'mng_movement_delivery',  to: '/portal/dashboard/movement-delivery',  iconClassName: <FastfoodIcon className={styles.menuIcon} /> },
            { name: 'mng_hourly_occupation', to: '/portal/dashboard/hourly-occupation', iconClassName: <QueryBuilderIcon className={styles.menuIcon} />, video: <ReactPlayer url={VideoPainelGestaoHoraria} playing={true} /> },
            { name: 'mng_hourly_prediction', to: '/portal/dashboard/hourly-prediction', iconClassName: <HistoryIcon className={styles.menuIcon} /> },
            { divider: true },
            { name: 'mng_condominium', to: '/portal/dashboard/condominium', iconClassName: <ImMakeGroup className={styles.menuIcon} /> },
            { name: 'mng_rewards', to: '/portal/dashboard/rewards', iconClassName: <GiCash className={styles.menuIcon} />, video: <ReactPlayer url={VideoPainelBeneficio} playing={true} />  }
        ],
    },
    {
        name: 'cadastre',
        to: '/portal/cadastre',
        iconClassName: <FaBook size={23} />,
        subMenus: [
            { name: 'category', to: '/portal/cadastre/category', iconClassName: <BiCategory size={23} /> },
            { name: 'product', to: '/portal/cadastre/product', iconClassName: <ShoppingCartIcon className={styles.menuIconSmall} /> },
            { divider: true },
            { name: 'partner', to: '/portal/cadastre/partner', iconClassName: <MdAddBusiness size={23} /> },
            { name: 'member', to: '/portal/cadastre/member', iconClassName: <FaUsers size={23} /> },
            { name: 'vessel', to: '/portal/cadastre/vessel', iconClassName: <FaShip size={23} /> },
            { divider: true },
            { name: 'beneficiary', to: '/portal/cadastre/benefit', iconClassName: <FaHouseUser size={23} /> },
            { divider: true },
            { name: 'purveyor', to: '/portal/cadastre/purveyor', iconClassName: <ImUserTie size={23} /> },
            { name: 'employee', to: '/portal/cadastre/employee', iconClassName: <PersonIcon className={styles.menuIcon} /> },
            { name: 'mechanic', to: '/portal/cadastre/mechanic', iconClassName: <FaUserCog size={23} /> }
        ],
    },
    { divider: true },
    { name: 'member',  to: '/portal/member', iconClassName: <FaUsers size={23} /> },
    { name: 'vessels', to: '/portal/vessel', iconClassName: <FaShip size={23} /> },
    { name: 'employee', to: '/portal/employee', iconClassName: <PersonIcon className={styles.menuIcon} /> },
    { name: 'mechanic', to: '/portal/mechanic', iconClassName: <FaUserCog className={styles.menuIcon} /> },
    { name: 'products', to: '/portal/product', iconClassName: <ShoppingCartIcon className={styles.menuIcon} /> },
    { divider: true },
    { name: 'delivery', to: '/portal/delivery', iconClassName: <FastfoodIcon className={styles.menuIcon} /> },
    { 
        name: 'condominium', 
        to: '/portal/condominium', 
        iconClassName: <ImMakeGroup size={23} />,
        subMenus: [
            { name: 'Cadastro', to: '/portal/condominium/register', iconClassName: <MdAppRegistration size={23} />, expanded: {isOpened: false}, subMenus: [
                { name: 'Imóvel', to: '/portal/condominium/register/estate', iconClassName: <MdOutlineDashboard size={23} />}]
            },
            { name: 'Consulta', to: '/portal/condominium/consultation', iconClassName: <MdSearch size={23} /> , expanded: {isOpened: false}, subMenus: [
                { name: 'Imóvel', to: '/portal/condominium/consultation/estate', iconClassName: <MdOutlineDashboard size={23} />},
                { name: 'Moradores', to: '/portal/condominium/consultation/resident', iconClassName: <MdOutlineDashboard size={23} />},
                { name: 'Visitantes', to: '/portal/condominium/consultation/visitor', iconClassName: <MdOutlineDashboard size={23} />},
                { name: 'Veículos', to: '/portal/condominium/consultation/vehicle', iconClassName: <MdOutlineDashboard size={23} />},
                { name: 'Embarcações', to: '/portal/condominium/consultation/vessel', iconClassName: <MdOutlineDashboard size={23} />},
                { name: 'Prestadores', to: '/portal/condominium/consultation/servant', iconClassName: <MdOutlineDashboard size={23} />}]
            },
            { name: 'Agenda', to: '/portal/condominium/schedule', iconClassName: <MdSchedule size={23} /> },
            { name: 'Avisos', to: '/portal/condominium/notices', iconClassName: <MdNotificationImportant size={23} /> },
            { name: 'Áreas Comuns', to: '/portal/condominium/common-areas', iconClassName: <MdSportsSoccer size={23} /> },
            { name: 'Entregas', to: '/portal/condominium/deliveries', iconClassName: <MdDeliveryDining size={23} />},
            { name: 'Ocorrências', to: '/portal/condominium/occurrences', iconClassName: <MdReportProblem size={23} />, expanded: {isOpened: false}, subMenus: [
                { name: 'Notificação', to: '/portal/condominium/occurrences/notification', iconClassName: <MdOutlineDashboard size={23} />},
                { name: 'Infração', to: '/portal/condominium/occurrences/infringement', iconClassName: <MdOutlineDashboard size={23} />},
                { name: 'Incidente', to: '/portal/condominium/occurrences/incident', iconClassName: <MdOutlineDashboard size={23} />}] },
            { name: 'Assembléias', to: '/portal/condominium/assemblies', iconClassName: <MdPeople size={23} /> },
            { name: 'Reuniões', to: '/portal/condominium/meetings', iconClassName: <MdPeople size={23} /> },
            { name: 'Achados e Perdidos', to: '/portal/condominium/lost-and-found', iconClassName: <MdManageSearch size={23} /> },
            { name: 'Financeiro', to: '/portal/condominium/finances', iconClassName: <MdCurrencyExchange size={23} />, expanded: {isOpened: false}, subMenus: [
                { name: 'Contratos', to: '/portal/condominium/finances/contracts', iconClassName: <MdOutlineDashboard size={23} />},
                { name: 'Gestão Contratos', to: '/portal/condominium/finances/contract-management', iconClassName: <MdOutlineDashboard size={23} />},
                { name: 'Gestão Moradores', to: '/portal/condominium/finances/residents-management', iconClassName: <MdOutlineDashboard size={23} />},
                { name: 'Cobranças', to: '/portal/condominium/finances/charge', iconClassName: <MdCurrencyExchange size={23} />},
                { name: 'DRE', to: '/portal/condominium/finances/dre', iconClassName: <MdOutlineDashboard size={23} />}]  }
            
        ],
    },
    { 
        name: 'benefit', 
        to: '/portal/benefit', 
        iconClassName: <GiCash className={styles.menuIcon} />,
        subMenus: [
            { name: 'rule', to: '/portal/benefit/rules', iconClassName: <MdRule size={23} /> }
        ],
    },
    { divider: true },
    { name: 'schedule', to: '/portal/schedule', iconClassName: <FaRegCalendarCheck size={23} /> },
    { divider: true },
    { 
        name: 'provideds', 
        to: '/portal/provideds', 
        iconClassName: <SettingsSuggestIcon className={styles.menuIcon} />,
        subMenus: [
            { name: 'cleaning', to: '/portal/provideds/cleaning', iconClassName: <WashIcon className={styles.menuIcon} /> },
        ],
    },
    {
        name: 'stock', 
        to: '/portal/stock', 
        iconClassName: <InventoryIcon className={styles.menuIcon} />,
        subMenus: [
            { name: 'search', to: '/portal/stock/search', iconClassName: <FaChartBar className={styles.menuIcon} /> },
        ],
    },
    /*
    {
        name: 'stock',
        to: '/portal/stock',
        iconClassName: <InventoryIcon className={styles.menuIcon} />,
        subMenus: [
            { name: 'movement', to: '/portal/stock/search', iconClassName: <SearchIcon className={styles.menuIcon} /> }
        ],
    },
    */
    /*{
        name: 'navigation',
        to: '/portal/navigation',
        iconClassName: <img
        alt="Navegando"
        src={Navegando}
        className={styles.menuIcon}
        style={{ height: 23, width: 23 }}
      />,
        subMenus: [
            { name: 'schedule', to: '/portal/navigation/schedule', iconClassName: <TodayIcon className={styles.menuIconSmall} /> },
            { name: 'navigation_plan', to: '/portal/navigation/navigation_plan', iconClassName: <ContentPasteIcon className={styles.menuIconSmall} /> },
            { name: 'history', to: '/portal/navigation/history', iconClassName: <HistoryIcon className={styles.menuIconSmall} /> },
        ],
    },*/
    {
        name: 'operation',
        to: '/portal/operation',
        iconClassName: <FaStoreAlt size={23} />,
        subMenus: [
            { name: 'movement', to: '/portal/operation/movement', iconClassName: <FaTractor size={23} /> },
            { name: 'navigation_plan', to: '/portal/operation/movement-history', iconClassName: <ContentPasteIcon className={styles.menuIconSmall} /> },
            { name: 'keep_boat', to: '/portal/operation/keep_boat', iconClassName: <FaWarehouse size={23} />, video: <ReactPlayer url={VideoMapaEmbarcacoes} playing={true} /> },
            { divider: true },
            { name: 'assessment', to: '/portal/operation/assessment', iconClassName: <MdAssessment size={23} /> }
        ],
    },
    {
        name: 'office',
        to: '/portal/office',
        iconClassName: <FaTools size={23} />,
        subMenus: [
            { name: 'budget', to: '/portal/office/budget', iconClassName: <FormatListBulletedIcon className={styles.menuIcon} /> },
            // { divider: true },
        ],
    },
    {
        name: 'financial',
        to: '/portal/financial',
        iconClassName: <AccountBalanceWalletIcon fontSize="medium" className={styles.menuIcon} />,
        subMenus: [
            { name: 'mng_contract', to: '/portal/financial/contract', iconClassName: <FaFileContract size={23} /> },
            { name: 'mng_contract_management', to: '/portal/financial/contract-management', iconClassName: <BadgeIcon className={styles.menuIcon} /> },
            { name: 'mng_contract_customer', to: '/portal/financial/contract-customer', iconClassName: <RiContactsBookFill className={styles.menuIcon} /> },
            { name: 'mng_launcher', to: '/portal/financial/launcher', iconClassName: <FaMoneyCheckAlt size={23} /> },
            //{ name: 'conciliation', to: '/portal/financial/conciliation', iconClassName: <FaCoins size={23} /> }
            { divider: true },
            { name: 'levy', to: '/portal/financial/levy-condominium', iconClassName: <FaFileContract size={23} /> },
            { name: 'contract', to: '/portal/financial/contract-condominium', iconClassName: <BadgeIcon className={styles.menuIcon} /> },
            { name: 'condominium', to: '/portal/financial/condominium', iconClassName: <ImMakeGroup size={23} /> },
            { name: 'DRE', to: '/portal/financial/dre', iconClassName: <CurrencyExchangeIcon className={styles.menuIcon} /> },
            { name: 'revenue_expense', to: '/portal/financial/revenue_expense-condominium', iconClassName: <FaBook size={23} /> },
        ],
    }
];

export interface ISideMenuProps {
    onCollapse: any,
    onCloseSideMenu: any,
    onSignout: any,
    showVideo: any,
    setShowVideo: any
}

export const SideMenu: React.FC<ISideMenuProps> = (props: ISideMenuProps) => {

    const { display } = useTranslateContext();

    const [ menuInactive, setMenuInactive ] = useState([{ isOpened: false, name: '' }] as any);

    const removeActiveClassFromSubMenu = () => {
        const elements = document.querySelectorAll(".sidebar-item");
        elements.forEach((element) => {
            element.classList.remove("active");
        });
    };

    function onClick_Logout(event: any) {
        event.preventDefault();

        authService.logout();
        window.location.href = '/';
    }
    
    useEffect(() => {
        let localMenuItems = document.querySelectorAll(".sidebar-item");
        localMenuItems.forEach((el) => {
            el.addEventListener("click", (e) => {
                removeActiveClassFromSubMenu();
                // localMenuItems.forEach((el) => el.classList.remove("active"));
                el.classList.toggle("active");
            });
        });

        let localMenuInactive = new Array(menuItems.length);
        for (var i = 0; i < menuItems.length; i++) {
            const item = menuItems[i];
            localMenuInactive[i] = {
                isOpened: false,
                name: item.name
            }; 
        }
        setMenuInactive(localMenuInactive);
    }, []);

    return (
        <>
            <Nav className={`sidebar ${props.onCollapse ? "toggled" : ""}`}>
                <div className="sidebar-content">
                    <a className="sidebar-brand" href="/">
                        <Image src={Logo} className="logo" />
                        <span className="align-middle"></span>
                    </a>
                    <div className={`sidebar-video ${props.showVideo.show ? 'show' : ''}`}>{props.showVideo.video}</div>
                    <ul className="sidebar-nav">
                        {menuItems.map((menuItem, index) => (
                            menuItem.divider ? (
                                <li className="sidebar-item" key={uuid()}><span className="sidebar-link"><span className="sidebar-divider"></span></span></li>
                            ) : (
                                authService.permissionIn(menuItem.name || '') &&
                                <MenuItem
                                    key={uuid()}
                                    name={menuItem.name}
                                    to={menuItem.to}
                                    subMenus={menuItem.subMenus || []}
                                    iconClassName={menuItem.iconClassName}
                                    onClick={(event: any) => {
                                        const updatedMenuInactive = menuInactive.map((standardItem: any, position: number) => {
                                            if ((index === position) && (event.target.innerText === display.menu[standardItem.name])) {
                                                return { ...standardItem, isOpened: !standardItem.isOpened };
                                            }
                                            return standardItem;
                                        });
                                        setMenuInactive(updatedMenuInactive);
                                    }}
                                    expanded={menuInactive[index]}
                                    onCloseSideMenu={props.onCloseSideMenu}
                                    setShowVideo={props.setShowVideo}
                                />
                            )
                        ))}
                    </ul>
                    <div className="sidebar-logout" onClick={(e) => onClick_Logout(e)}>
                        <FaSignOutAlt />{display.label.go_out}
                    </div>
                </div>
            </Nav>
        </>
    )

}
